import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/configuracao')({
  component: CadastroLayout,
});

function CadastroLayout() {
  return <Outlet />;
}
